import { ActionTypes as UIActions } from '../actions/ui'
import { closeErrorMessage } from '../actions/upload'

export interface UIState {
  uploadBtnDisabled?: boolean
  alertFileSize: boolean
  alertFileType: boolean
}

const initialState = {
  uploadBtnDisabled: true,
  alertFileSize: false,
  alertFileType: false,
}

export function uiReducer(state = initialState, action: any) {
  switch (action.type) {
    case UIActions.SHOW:
      return {
        ...state,
        [action.key]: true,
      }
    case UIActions.HIDE:
      return {
        ...state,
        [action.key]: false,
      }
    case closeErrorMessage:
      return {
        ...state,
        alertFileSize: false,
        alertFileType: false,
      }
    default:
      return state
  }
}

export default uiReducer
